import anime from 'animejs/lib/anime.es.js';

export const PXVideo = (function () {
	'use strict';

	let blocks;

	function init() {
		blocks = document.querySelectorAll('.pxblock--video');

		blocks.forEach((block) => {
			const background = block.querySelector('.media-bg');
			const playButton = block.querySelector('.video-button');
			const followWrapper = block.querySelector('.follow-wrapper');
			const toggleButton = block.querySelector('.media-bg-toggle');
			const video = block.querySelector('video');

			let vWidth = 0
			let vHeight = 0
			let bWidth = 0
			let bHeight = 0
			let mousing = false

			const resetButton = () => {
				playButton.classList.add('in-place');
				followWrapper.style.top = `0`
				followWrapper.style.left = `0`
				followWrapper.style.transform = `translate(${vWidth - (bWidth / 2) - 20}px, ${vHeight - (bHeight / 2) - 60}px)`
				mousing = false
			}

			const onResize = () => {
				const vRect = background.getBoundingClientRect()
				vWidth = vRect.width
				vHeight = vRect.height
				const bRect = playButton.getBoundingClientRect()
				bWidth = bRect.width
				bHeight = bRect.height
				!mousing && resetButton()
			}



			const followButton = (ev) => {
				const bgRect = background.getBoundingClientRect()
				const offX = ev.clientX - bgRect.left
				const offY = ev.clientY - bgRect.top
				const halfW = bWidth * 0.6
				const halfH = bHeight * 0.6
				const xPixels = Math.min(Math.max(offX, halfW), vWidth - halfW)
				const yPixels = Math.min(Math.max(offY, halfH), vHeight - halfH)
				mousing = true
				followWrapper.style.transform = `translate(${xPixels}px, ${yPixels}px)`
				playButton.classList.remove('in-place')

			}

			if (video !== null && playButton) {
				playButton.addEventListener('click', (ev) => {
					video.pause();
				});
			}

			if (video && toggleButton) {
				toggleButton.addEventListener('click', (ev) => {
					ev.stopImmediatePropagation()
					console.log('click', ev)
					if (video.paused) {
						video.play()
						toggleButton.innerHTML = '<span>Stop Background</span>'
					} else {
						video.pause()
						toggleButton.innerHTML = '<span>Start Background</span>'
					}
				})
				toggleButton.addEventListener('mousemove', (ev) => {
					ev.stopImmediatePropagation()
				})
				toggleButton.addEventListener('mouseenter', (ev) => {
					ev.stopImmediatePropagation()
					resetButton()
				})
			}

			if (background && playButton) {
				background.addEventListener('mouseenter', (ev) => playButton.classList.remove('in-place'));

				background.addEventListener('mouseleave', (ev) => {
					resetButton()
				});

				background.addEventListener('mousemove', (ev) => {
					followButton(ev)
				});

				background.addEventListener('click', (ev) => {
					video.pause();
					playButton.click()
				});

				window.addEventListener('resize', onResize, { passive: true })
				onResize()
				playButton.classList.add('ready')
			}
		});
	}

	return {
		init: init,
	};
})();
